import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, signal, Component, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, ViewChildren, Input, Output, ContentChild, InjectionToken, Injectable, Optional, Inject, NgModule } from '@angular/core';
import * as i10 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { fromFilterString, toFilterString, fusion } from '@js-dot/core';
import { fromSortString, toSortString, updateSortObject } from '@js-dot/core/route';
import { DotComponent, DotIncludesPipe, DotPromisifyPipe } from '@ng-dot/core';
import * as i8 from '@ng-dot/form/input';
import { DotInputModule } from '@ng-dot/form/input';
import * as i1 from '@ng-dot/route';
import { DotSelfUrlService } from '@ng-dot/route';
import { DotOfDefinePipe } from '@ng-dot/text';
import * as i2 from '@ng-dot/ui/container';
import { DotContainerDirective } from '@ng-dot/ui/container';
import * as i5 from '@ng-dot/ui/frame';
import { DotFrameModule } from '@ng-dot/ui/frame';
import * as i7 from '@ng-dot/ui/icon';
import { DotIconModule } from '@ng-dot/ui/icon';
import * as i6 from '@ng-dot/ui/link';
import { DotLinkModule } from '@ng-dot/ui/link';
import * as i4 from '@ng-dot/ui/list';
import { DotListModule } from '@ng-dot/ui/list';
import { DotListFilterKeywordPipe } from '@ng-dot/ui/list-filter';
import * as i9 from '@ng-dot/ui/to-more-links';
import { DotToMoreLinksModule } from '@ng-dot/ui/to-more-links';
import { DotCheckboxesDirective, DotCheckboxDirective, DotCheckboxesToggleDirective } from '@ng-dot/ux/checkboxes';
import { DotListComponentBase, DotListValuePipe, DotListDescriptionPipe, DotListLinkPipe } from '@ng-dot/ux/list';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

/**
 * @example Customize Item
 *
 * ```html
 * <dot-dualist>
 *     <ng-template #listItem let-items let-item="item">
 *         <dot-list-item [class]="item.className">
 * 	       		<ng-container *ngTemplateOutlet="items" />
 *         </dot-list-item>
 *     </ng-template>
 * </dot-dualist>
 * ```
 *
 * @example Customize Item Actions
 *
 * ```html
 * <dot-dualist>
 *     <ng-template #listActions let-item>
 *         <button (click)="update(item)">Update</button>
 *         <button (click)="delete(item)">Delete</button>
 *     </ng-template>
 * </dot-dualist>
 * ```
 */
const _c0 = ["listBefore"];
const _c1 = ["listAfter"];
const _c2 = ["listItem"];
const _c3 = ["listPrependHeads"];
const _c4 = ["listPrepends"];
const _c5 = ["listAppendHeads"];
const _c6 = ["listAppends"];
const _c7 = ["listActions"];
const _c8 = ["listEmpty"];
const _c9 = a0 => ({
  $implicit: a0
});
const _c10 = () => ["select", "date"];
const _c11 = (a0, a1) => ({
  $implicit: a0,
  index: a1
});
const _c12 = (a0, a1, a2) => ({
  $implicit: a0,
  item: a1,
  index: a2
});
function DotDualistComponent_ng_template_0_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
    i0.ɵɵpipe(1, "icon");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r2.configure.sortAscIcon), i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_0_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
    i0.ɵɵpipe(1, "icon");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r2.configure.sortDescIcon), i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_0_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
    i0.ɵɵpipe(1, "icon");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r2.configure.sortToggleIcon), i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 12)(1, "button", 13);
    i0.ɵɵpipe(2, "ofDefine");
    i0.ɵɵlistener("click", function DotDualistComponent_ng_template_0_Template_button_click_1_listener() {
      const adjust_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listSortToggle(adjust_r2.target));
    });
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵtemplate(4, DotDualistComponent_ng_template_0_Case_4_Template, 2, 3, "span", 14)(5, DotDualistComponent_ng_template_0_Case_5_Template, 2, 3, "span", 14)(6, DotDualistComponent_ng_template_0_Case_6_Template, 2, 3, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 15);
    i0.ɵɵpipe(8, "icon");
    i0.ɵɵpipe(9, "ofDefine");
    i0.ɵɵlistener("click", function DotDualistComponent_ng_template_0_Template_button_click_7_listener() {
      const adjust_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listSortAsc(adjust_r2.target));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 16);
    i0.ɵɵpipe(11, "icon");
    i0.ɵɵpipe(12, "ofDefine");
    i0.ɵɵlistener("click", function DotDualistComponent_ng_template_0_Template_button_click_10_listener() {
      const adjust_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listSortDesc(adjust_r2.target));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_7_0;
    const adjust_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tip", i0.ɵɵpipeBind1(2, 12, ctx_r2.configure.sortToggleDefine))("tipDelay", ctx_r2.tipDelay);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", adjust_r2.headingValue, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_7_0 = ctx_r2._listSorts$()[adjust_r2.target]) === true ? 4 : tmp_7_0 === false ? 5 : 6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(8, 14, ctx_r2.configure.sortAscIcon), i0.ɵɵsanitizeHtml)("tip", i0.ɵɵpipeBind1(9, 16, ctx_r2.configure.sortAscDefine))("tipDelay", ctx_r2.tipDelay)("active", ctx_r2._listSorts$()[adjust_r2.target] === true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(11, 18, ctx_r2.configure.sortDescIcon), i0.ɵɵsanitizeHtml)("tip", i0.ɵɵpipeBind1(12, 20, ctx_r2.configure.sortDescDefine))("tipDelay", ctx_r2.tipDelay)("active", ctx_r2._listSorts$()[adjust_r2.target] === false);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dot-component", 18);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    const adjust_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("option", option_r4)("data", adjust_r5);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_dot_label_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dot-label", 29);
  }
  if (rf & 2) {
    const value_r7 = ctx.$implicit;
    i0.ɵɵproperty("textContent", value_r7);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
  }
  if (rf & 2) {
    const value_r8 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", value_r8, i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_option_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "option", 31);
  }
  if (rf & 2) {
    const option_r9 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r9.value)("innerHTML", option_r9.text, i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 32);
  }
  if (rf & 2) {
    const value_r10 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", value_r10, i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dot-inputs")(2, "label", 22);
    i0.ɵɵtemplate(3, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_dot_label_3_Template, 1, 1, "dot-label", 23)(4, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_span_4_Template, 1, 1, "span", 24);
    i0.ɵɵelementStart(5, "select", 25);
    i0.ɵɵlistener("change", function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_Template_select_change_5_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const adjust_r5 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listFilterOnChange($event, adjust_r5));
    });
    i0.ɵɵelement(6, "option", 14);
    i0.ɵɵpipe(7, "ofDefine");
    i0.ɵɵtemplate(8, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_option_8_Template, 1, 2, "option", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_span_9_Template, 1, 1, "span", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_ng_container_10_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const displayFilterActions_r11 = i0.ɵɵreference(5);
    const adjust_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", adjust_r5.filter.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", adjust_r5.filter.prefix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r2._listKeywords$()[adjust_r5.target]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(7, 7, "LIST_FILTER_SELECT_PLACEHOLDER"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", adjust_r5.filter.options);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", adjust_r5.filter.suffix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", displayFilterActions_r11);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 36);
  }
  if (rf & 2) {
    const label_r13 = ctx.$implicit;
    i0.ɵɵproperty("textContent", label_r13);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
  }
  if (rf & 2) {
    const value_r14 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", value_r14, i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 32);
  }
  if (rf & 2) {
    const value_r16 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", value_r16, i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dot-inputs")(2, "label", 22);
    i0.ɵɵtemplate(3, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_span_3_Template, 1, 1, "span", 33)(4, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_span_4_Template, 1, 1, "span", 24);
    i0.ɵɵelementStart(5, "input", 34, 4);
    i0.ɵɵpipe(7, "listFilterKeyword");
    i0.ɵɵlistener("keyup", function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_Template_input_keyup_5_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const adjust_r5 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listOnFilterKeyUp($event, adjust_r5));
    })("change", function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_Template_input_change_5_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const adjust_r5 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listFilterOnChange($event, adjust_r5));
    })("focus", function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_Template_input_focus_5_listener() {
      i0.ɵɵrestoreView(_r12);
      const input_r15 = i0.ɵɵreference(6);
      return i0.ɵɵresetView(input_r15.showPicker());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_span_8_Template, 1, 1, "span", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_ng_container_9_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const input_r15 = i0.ɵɵreference(6);
    i0.ɵɵnextContext();
    const displayFilterActions_r11 = i0.ɵɵreference(5);
    const adjust_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", adjust_r5.filter.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", adjust_r5.filter.prefix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", adjust_r5.filter.type)("ngModel", i0.ɵɵpipeBind1(7, 7, ctx_r2._listKeywords$()[adjust_r5.target]));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", adjust_r5.filter.suffix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", displayFilterActions_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c9, input_r15));
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 36);
  }
  if (rf & 2) {
    const label_r18 = ctx.$implicit;
    i0.ɵɵproperty("textContent", label_r18);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
  }
  if (rf & 2) {
    const value_r19 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", value_r19, i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 32);
  }
  if (rf & 2) {
    const value_r20 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", value_r20, i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dot-inputs")(2, "label", 22);
    i0.ɵɵtemplate(3, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_span_3_Template, 1, 1, "span", 33)(4, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_span_4_Template, 1, 1, "span", 24);
    i0.ɵɵelementStart(5, "input", 37, 4);
    i0.ɵɵpipe(7, "ofDefine");
    i0.ɵɵlistener("keyup", function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_Template_input_keyup_5_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const adjust_r5 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listOnFilterKeyUp($event, adjust_r5));
    })("change", function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_Template_input_change_5_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const adjust_r5 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listFilterOnChange($event, adjust_r5));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_span_8_Template, 1, 1, "span", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_ng_container_9_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const input_r21 = i0.ɵɵreference(6);
    i0.ɵɵnextContext();
    const displayFilterActions_r11 = i0.ɵɵreference(5);
    const adjust_r5 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", adjust_r5.filter.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", adjust_r5.filter.prefix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", adjust_r5.filter.type)("placeholder", i0.ɵɵpipeBind1(7, 8, "LIST_FILTER_TEXT_PLACEHOLDER"))("ngModel", ctx_r2._listKeywords$()[adjust_r5.target]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", adjust_r5.filter.suffix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", displayFilterActions_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c9, input_r21));
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_template_4_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 40);
    i0.ɵɵpipe(1, "icon");
    i0.ɵɵpipe(2, "ofDefine");
    i0.ɵɵlistener("click", function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_template_4_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r22);
      const adjust_r5 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.listFilterCancel(adjust_r5));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 3, ctx_r2.configure.filterCancelIcon), i0.ɵɵsanitizeHtml)("tip", i0.ɵɵpipeBind1(2, 5, "LIST_FILTER_CANCEL"))("tipDelay", ctx_r2.tipDelay);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_template_4_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 41);
    i0.ɵɵpipe(1, "icon");
    i0.ɵɵpipe(2, "ofDefine");
    i0.ɵɵlistener("click", function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_template_4_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r23);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.listFilterSubmit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 3, ctx_r2.configure.filterSubmitIcon), i0.ɵɵsanitizeHtml)("tip", i0.ɵɵpipeBind1(2, 5, "LIST_FILTER_SUBMIT"))("tipDelay", ctx_r2.tipDelay);
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dot-input-actions");
    i0.ɵɵtemplate(1, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_template_4_button_1_Template, 3, 7, "button", 38)(2, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_template_4_button_2_Template, 3, 7, "button", 39);
    i0.ɵɵpipe(3, "includes");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const adjust_r5 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2._listKeywords$()[adjust_r5.target]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind2(3, 2, i0.ɵɵpureFunction0(5, _c10), adjust_r5.filter.type));
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dot-input-area", 19);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_1_Template, 11, 9, "ng-container", 20)(2, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_2_Template, 10, 11, "ng-container", 20)(3, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_container_3_Template, 10, 12, "ng-container", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_ng_template_4_Template, 4, 6, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const adjust_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngSwitch", adjust_r5.filter.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "select");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "date");
  }
}
function DotDualistComponent_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_template_2_ng_container_0_ng_container_1_Template, 2, 2, "ng-container", 17)(2, DotDualistComponent_ng_template_2_ng_container_0_ng_template_2_Template, 6, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const displayHeadFilterControl_r24 = i0.ɵɵreference(3);
    const adjust_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", adjust_r5.filter.component)("ngIfElse", displayHeadFilterControl_r24);
  }
}
function DotDualistComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_template_2_ng_container_0_Template, 4, 2, "ng-container", 11);
  }
  if (rf & 2) {
    const adjust_r5 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", adjust_r5.filter);
  }
}
function DotDualistComponent_ng_container_5_ng_template_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dl", 48)(1, "dd")(2, "dot-input-area")(3, "dot-inputs")(4, "label", 22);
    i0.ɵɵelement(5, "input", 49);
    i0.ɵɵelementEnd()()()()();
  }
}
function DotDualistComponent_ng_container_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_ng_template_1_Conditional_0_Template, 6, 0, "dl", 48);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r2.listCheckbox ? 0 : -1);
  }
}
function DotDualistComponent_ng_container_5_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_Conditional_7_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_Conditional_7_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.prependHeadsTemplate);
  }
}
function DotDualistComponent_ng_container_5_For_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dt", 50);
  }
  if (rf & 2) {
    i0.ɵɵproperty("option", ctx);
  }
}
function DotDualistComponent_ng_container_5_For_9_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_For_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_For_9_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 35);
  }
  if (rf & 2) {
    const adjust_r25 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(2);
    const headSort_r26 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", headSort_r26)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c9, adjust_r25));
  }
}
function DotDualistComponent_ng_container_5_For_9_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dt", 14);
  }
  if (rf & 2) {
    const adjust_r25 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", adjust_r25.headingValue, i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_container_5_For_9_dd_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_For_9_dd_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dd", 52);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_For_9_dd_4_ng_container_1_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const adjust_r25 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(2);
    const displayHeadFilter_r27 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", displayHeadFilter_r27)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c9, adjust_r25));
  }
}
function DotDualistComponent_ng_container_5_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dl", 44);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_For_9_Conditional_1_Template, 1, 1, "dt", 50)(2, DotDualistComponent_ng_container_5_For_9_Conditional_2_Template, 1, 4, "ng-container")(3, DotDualistComponent_ng_container_5_For_9_Conditional_3_Template, 1, 1, "dt", 14)(4, DotDualistComponent_ng_container_5_For_9_dd_4_Template, 2, 4, "dd", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_17_0;
    const adjust_r25 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("key", adjust_r25.key)("ngClass", adjust_r25.className);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_17_0 = adjust_r25.heading.component) ? 1 : ctx_r2.listSort && adjust_r25.sort ? 2 : 3, tmp_17_0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.outerFilter && ctx_r2.listFilter && ctx_r2.configure.filter.position !== "foot");
  }
}
function DotDualistComponent_ng_container_5_Conditional_10_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_Conditional_10_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.appendHeadsTemplate);
  }
}
function DotDualistComponent_ng_container_5_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dl", 45);
    i0.ɵɵpipe(1, "ofDefine");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r2.configure.actionsDefine), i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dl", 54)(1, "dd")(2, "dot-input-area")(3, "dot-inputs")(4, "label", 22);
    i0.ɵɵelement(5, "input", 55);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const item_r28 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("data", item_r28);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext();
    const item_r28 = ctx_r28.$implicit;
    const index_r30 = ctx_r28.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.prependsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c11, item_r28, index_r30));
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dd");
    i0.ɵɵelement(1, "dot-component", 18);
    i0.ɵɵpipe(2, "dotListValue");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const adjust_r31 = i0.ɵɵnextContext(2).$implicit;
    const item_r28 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("option", ctx)("data", i0.ɵɵpipeBind2(2, 2, item_r28, adjust_r31));
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dd", 14);
    i0.ɵɵpipe(1, "dotListValue");
  }
  if (rf & 2) {
    const adjust_r31 = i0.ɵɵnextContext(2).$implicit;
    const item_r28 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, item_r28, adjust_r31), i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_dd_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dd");
    i0.ɵɵelement(1, "dot-component", 18);
    i0.ɵɵpipe(2, "dotListDescription");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const component_r32 = ctx.$implicit;
    const adjust_r31 = i0.ɵɵnextContext(2).$implicit;
    const item_r28 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("option", component_r32)("data", i0.ɵɵpipeBind2(2, 2, item_r28, adjust_r31));
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_ng_template_3_dd_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dd", 14);
    i0.ɵɵpipe(1, "dotListDescription");
  }
  if (rf & 2) {
    const adjust_r31 = i0.ɵɵnextContext(3).$implicit;
    const item_r28 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, item_r28, adjust_r31), i0.ɵɵsanitizeHtml);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_ng_template_3_dd_0_Template, 2, 4, "dd", 56);
  }
  if (rf & 2) {
    const adjust_r31 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngIf", adjust_r31.description);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_Conditional_0_Template, 3, 5, "dd")(1, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_Conditional_1_Template, 2, 4, "dd", 14)(2, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_dd_2_Template, 3, 5, "dd", 17)(3, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_ng_template_3_Template, 1, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    let tmp_24_0;
    const displayDescriptionText_r33 = i0.ɵɵreference(4);
    const adjust_r31 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional((tmp_24_0 = adjust_r31.value.component) ? 0 : 1, tmp_24_0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", adjust_r31.description == null ? null : adjust_r31.description.component)("ngIfElse", displayDescriptionText_r33);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 57);
    i0.ɵɵpipe(2, "dotListLink");
    i0.ɵɵpipe(3, "promisify");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_3_ng_container_5_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const adjust_r31 = i0.ɵɵnextContext().$implicit;
    const dds_r34 = i0.ɵɵreference(1);
    const item_r28 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("key", adjust_r31.key)("routerLink", i0.ɵɵpipeBind2(2, 8, item_r28, adjust_r31))("queryParams", ctx_r2.routeParams)("label", adjust_r31.headingValue)("tip", i0.ɵɵpipeBind1(4, 13, i0.ɵɵpipeBind1(3, 11, adjust_r31.tip)))("tipDelay", ctx_r2.tipDelay)("ngClass", adjust_r31.className);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", dds_r34);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_4_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dl", 58);
    i0.ɵɵpipe(2, "promisify");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵlistener("click", function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_4_Template_dl_click_1_listener() {
      i0.ɵɵrestoreView(_r35);
      const adjust_r31 = i0.ɵɵnextContext().$implicit;
      const item_r28 = i0.ɵɵnextContext().$implicit;
      return i0.ɵɵresetView(adjust_r31.click(item_r28));
    });
    i0.ɵɵtemplate(4, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_4_ng_container_4_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const adjust_r31 = i0.ɵɵnextContext().$implicit;
    const dds_r34 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("key", adjust_r31.key)("label", adjust_r31.headingValue)("tip", i0.ɵɵpipeBind1(3, 8, i0.ɵɵpipeBind1(2, 6, adjust_r31.tip)))("tipDelay", ctx_r2.tipDelay)("ngClass", adjust_r31.className);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", dds_r34);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_5_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dl", 59);
    i0.ɵɵpipe(2, "promisify");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_5_ng_container_4_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const adjust_r31 = i0.ɵɵnextContext().$implicit;
    const dds_r34 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("key", adjust_r31.key)("label", adjust_r31.headingValue)("tip", i0.ɵɵpipeBind1(3, 8, i0.ɵɵpipeBind1(2, 6, adjust_r31.tip)))("tipDelay", ctx_r2.tipDelay)("ngClass", adjust_r31.className);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", dds_r34);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_template_0_Template, 5, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerStart(2, 19);
    i0.ɵɵtemplate(3, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_3_Template, 6, 15, "ng-container", 20)(4, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_4_Template, 5, 10, "ng-container", 20)(5, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_ng_container_5_Template, 5, 10, "ng-container", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const adjust_r31 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", adjust_r31.eventType);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "route");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "click");
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext();
    const item_r28 = ctx_r28.$implicit;
    const index_r30 = ctx_r28.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.appendsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c11, item_r28, index_r30));
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_5_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dl", 60);
    i0.ɵɵpipe(2, "ofDefine");
    i0.ɵɵelementStart(3, "dot-to-more-links", 61);
    i0.ɵɵtemplate(4, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_5_ng_container_4_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r28 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(2, 4, ctx_r2.configure.actionsDefine));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("moreAt", ctx_r2.actionsMoreAt);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.actionsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c9, item_r28));
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_Conditional_0_Template, 6, 1, "dl", 54)(1, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_1_Template, 2, 5, "ng-container", 11);
    i0.ɵɵrepeaterCreate(2, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_For_3_Template, 6, 3, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵtemplate(4, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_4_Template, 2, 5, "ng-container", 11)(5, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_ng_container_5_Template, 5, 8, "ng-container", 11);
  }
  if (rf & 2) {
    const adjusts_r36 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.listCheckbox ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.prependsTemplate);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(adjusts_r36);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.appendsTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.actionsTemplate);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_For_1_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_For_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_For_1_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 35);
  }
  if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext();
    const item_r38 = ctx_r36.$implicit;
    const $index_r39 = ctx_r36.$index;
    i0.ɵɵnextContext(2);
    const bodyItem_r40 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", bodyItem_r40)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c11, item_r38, $index_r39));
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_For_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_For_1_ng_template_0_Template, 1, 5, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor)(2, DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_For_1_ng_container_2_Template, 1, 0, "ng-container", 35);
  }
  if (rf & 2) {
    const item_r38 = ctx.$implicit;
    const $index_r39 = ctx.$index;
    const displayBodyWithTemplate_r41 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c12, displayBodyWithTemplate_r41, item_r38, $index_r39));
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_For_1_Template, 3, 6, null, null, i0.ɵɵcomponentInstance().listTrackBy, true);
  }
  if (rf & 2) {
    const items_r42 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵrepeater(items_r42);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_5_For_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_5_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dot-list-item");
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_5_For_1_ng_container_1_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r43 = ctx.$implicit;
    const $index_r44 = ctx.$index;
    i0.ɵɵnextContext(2);
    const bodyItem_r40 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", bodyItem_r40)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c11, item_r43, $index_r44));
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_5_For_1_Template, 2, 5, "dot-list-item", null, i0.ɵɵcomponentInstance().listTrackBy, true);
  }
  if (rf & 2) {
    const items_r42 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵrepeater(items_r42);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_body_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dot-list-body", 53);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_dot_list_body_12_ng_container_1_Template, 1, 0, "ng-container", 28)(2, DotDualistComponent_ng_container_5_dot_list_body_12_ng_template_2_Template, 6, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(4, DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_4_Template, 2, 0)(5, DotDualistComponent_ng_container_5_dot_list_body_12_Conditional_5_Template, 2, 0)(6, DotDualistComponent_ng_container_5_dot_list_body_12_ng_container_6_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.beforeTemplate);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r2.itemTemplate ? 4 : 5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.afterTemplate);
  }
}
function DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.prependHeadsTemplate);
  }
}
function DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "dl", 64)(2, "dd", 52);
    i0.ɵɵtemplate(3, DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_3_ng_container_3_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const adjust_r45 = ctx.$implicit;
    i0.ɵɵnextContext(3);
    const displayHeadFilter_r27 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("key", adjust_r45.key);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", displayHeadFilter_r27)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c9, adjust_r45));
  }
}
function DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.appendHeadsTemplate);
  }
}
function DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "dl", 65);
    i0.ɵɵelementContainerEnd();
  }
}
function DotDualistComponent_ng_container_5_dot_list_foot_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dot-list-foot", 62);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_1_Template, 1, 0, "ng-container", 28)(2, DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_2_Template, 2, 1, "ng-container", 11)(3, DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_3_Template, 4, 5, "ng-container", 63)(4, DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_4_Template, 2, 1, "ng-container", 11)(5, DotDualistComponent_ng_container_5_dot_list_foot_13_ng_container_5_Template, 2, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const adjusts_r36 = i0.ɵɵnextContext().$implicit;
    const headCheckbox_r46 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", headCheckbox_r46);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.prependHeadsTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", adjusts_r36);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.appendHeadsTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.actionsTemplate);
  }
}
function DotDualistComponent_ng_container_5_Conditional_14_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotDualistComponent_ng_container_5_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotDualistComponent_ng_container_5_Conditional_14_ng_container_0_Template, 1, 0, "ng-container", 28);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.emptyTemplate);
  }
}
function DotDualistComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DotDualistComponent_ng_container_5_ng_template_1_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "dot-list", 42)(4, "dot-list-head", 43)(5, "dot-list-item");
    i0.ɵɵtemplate(6, DotDualistComponent_ng_container_5_ng_container_6_Template, 1, 0, "ng-container", 28)(7, DotDualistComponent_ng_container_5_Conditional_7_Template, 1, 1, "ng-container");
    i0.ɵɵrepeaterCreate(8, DotDualistComponent_ng_container_5_For_9_Template, 5, 4, "dl", 44, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(10, DotDualistComponent_ng_container_5_Conditional_10_Template, 1, 1, "ng-container")(11, DotDualistComponent_ng_container_5_Conditional_11_Template, 2, 3, "dl", 45);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, DotDualistComponent_ng_container_5_dot_list_body_12_Template, 7, 3, "dot-list-body", 46)(13, DotDualistComponent_ng_container_5_dot_list_foot_13_Template, 6, 5, "dot-list-foot", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, DotDualistComponent_ng_container_5_Conditional_14_Template, 1, 1, "ng-container");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const adjusts_r36 = ctx.$implicit;
    const headCheckbox_r46 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("table", ctx_r2.table);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", headCheckbox_r46);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.prependHeadsTemplate ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(adjusts_r36);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.appendHeadsTemplate ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.actionsTemplate ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.listItems$());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.listFilter && ctx_r2.configure.filter.position !== "head");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.listItems$() && ctx_r2.listItems$().length === 0 && ctx_r2.emptyTemplate ? 14 : -1);
  }
}
class DotDualistComponent extends DotListComponentBase {
  _dualist;
  _route;
  _url;
  checkboxes;
  inputs;
  /**
   * dot-to-more-links[moreAt]
   */
  actionsMoreAt = 1200;
  /**
   * dotTip[delay]
   */
  tipDelay = 920;
  outerFilter;
  checks$ = new EventEmitter();
  checkSingle$ = new EventEmitter();
  checkMulti$ = new BehaviorSubject(false);
  checkAll$ = new EventEmitter();
  beforeTemplate;
  afterTemplate;
  /**
   * Display Item with External Template
   */
  itemTemplate;
  prependHeadsTemplate;
  prependsTemplate;
  appendHeadsTemplate;
  appendsTemplate;
  /**
   * Display Item Actions to Most-right
   */
  actionsTemplate;
  /**
   * Display Item length is 0
   */
  emptyTemplate;
  _destroy$ = new Subject();
  get configure() {
    return this._dualist.configure;
  }
  _listKeywords$ = signal({});
  _listSorts$ = signal({});
  _routeParams;
  get routeParams() {
    return this._routeParams;
  }
  // protected _listFilter$                          = signal<Record<string, boolean>>({})
  constructor(_dualist, _route, _url
  // @Host() _zone: DotZoneDirective
  ) {
    super();
    this._dualist = _dualist;
    this._route = _route;
    this._url = _url;
    // _zone.name = 'datatable';
  }
  ngOnChanges(changes) {
    super.ngOnChanges(changes);
    if ('listItems' in changes) {
      this._routeParams = this._route.params;
    }
    // if ('outerFilterComponent' in changes) {
    // 	this.outerFilterComponent.setList(this);
    // }
  }
  ngAfterViewInit() {
    const {
      _destroy$,
      checkboxes
    } = this;
    checkboxes.setQueryList(this.inputs);
    this.inputs.changes.subscribe(inputs => {
      checkboxes.setQueryList(inputs);
    });
    checkboxes.checks$.pipe(takeUntil(_destroy$)).subscribe(flag => this.checks$.emit(flag));
    checkboxes.single$.pipe(takeUntil(_destroy$)).subscribe(flag => this.checkSingle$.emit(flag));
    checkboxes.multi$.pipe(takeUntil(_destroy$)).subscribe(flag => this.checkMulti$.next(flag));
    checkboxes.all$.pipe(takeUntil(_destroy$)).subscribe(flag => this.checkAll$.emit(flag));
    const {
      _url
    } = this;
    if (this.listSort) {
      _url.get$('$sort').subscribe(sortString => {
        this._listSorts$.set(fromSortString(sortString));
      });
    }
    if (this.listFilter) {
      _url.get$('$filter').subscribe(filterString => {
        if (filterString) {
          this._listKeywords$.set(fromFilterString(filterString, {
            types: this.listFilterTypes$()
          }));
        }
      });
    }
  }
  /**
   * 체크박스 전체 선택
   */
  checkAll() {
    this.checkboxes.checks();
  }
  /**
   * 체크박스 전체 미선택
   */
  uncheckAll() {
    this.checkboxes.unchecks();
  }
  /**
   * 체크박스 전체 상태 변경
   */
  checkToggle() {
    this.checkboxes.toggles();
  }
  usingIdLike(index, target) {
    return target['seq'] || target['id'] || target['key'];
  }
  _listSetSortUrl() {
    this._url.set('$sort', toSortString(this._listSorts$()));
  }
  _listSetSort(target, descend) {
    const sortObject = this._listSorts$();
    updateSortObject(sortObject, target, descend);
    this._listSorts$.set({
      ...sortObject
    });
    this._listSetSortUrl();
  }
  listSortToggle(target) {
    const sortObject = this._listSorts$();
    switch (sortObject[target]) {
      case true:
        sortObject[target] = false;
        break;
      case false:
        delete sortObject[target];
        break;
      default:
        sortObject[target] = true;
    }
    this._listSetSortUrl();
  }
  listSortAsc(target) {
    this._listSetSort(target);
  }
  listSortDesc(target) {
    this._listSetSort(target, true);
  }
  listFilterSubmit() {
    this._url.set({
      $page: 1,
      $filter: toFilterString(this._listKeywords$())
    });
  }
  listFilterCancel(adjust) {
    const {
      filter: {
        target
      }
    } = adjust;
    const {
      _listKeywords$
    } = this;
    const keywords = _listKeywords$();
    delete keywords[target];
    _listKeywords$.set(keywords);
    this._route.update$(null, {
      filter: toFilterString(keywords)
    });
  }
  listOnFilterKeyUp(event, adjust) {
    const {
      filter: {
        target
      }
    } = adjust;
    switch (event.key) {
      case 'Enter':
        this.listFilterSubmit();
        return;
      case 'Escape':
        this.listFilterCancel(adjust);
        return;
    }
    const {
      _listKeywords$
    } = this;
    const keywords = _listKeywords$();
    keywords[target] = event.target.value;
    _listKeywords$.set(keywords);
  }
  listFilterOnChange(event, adjust, submit = true) {
    const {
      _listKeywords$
    } = this;
    const target = adjust.filter.target;
    const keywords = _listKeywords$();
    const value = event.target.value;
    switch (adjust.filter['type']) {
      case 'select':
        const {
          options,
          selectedIndex
        } = event.target;
        if (selectedIndex === 0 && options[0].getAttribute('value') === null) {
          delete keywords[target];
        } else {
          keywords[target] = options[selectedIndex].value;
        }
        break;
      case 'date':
        keywords[target] = value ? new Date(event.target.value) : null;
        break;
      default:
        keywords[target] = value;
    }
    _listKeywords$.set(keywords);
    submit && this.listFilterSubmit();
  }
  listSetFilter(target, value) {
    const {
      _listKeywords$
    } = this;
    _listKeywords$.set({
      ..._listKeywords$(),
      [target]: value
    });
    this.listFilterSubmit();
  }
  listDatePicker(input) {
    input.showPicker();
  }
  JSON = JSON;
  static ɵfac = function DotDualistComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotDualistComponent)(i0.ɵɵdirectiveInject(DotDualistService), i0.ɵɵdirectiveInject(i1.DotRouteService), i0.ɵɵdirectiveInject(i1.DotSelfUrlService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotDualistComponent,
    selectors: [["dot-dualist"]],
    contentQueries: function DotDualistComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, _c0, 7);
        i0.ɵɵcontentQuery(dirIndex, _c1, 7);
        i0.ɵɵcontentQuery(dirIndex, _c2, 7);
        i0.ɵɵcontentQuery(dirIndex, _c3, 7);
        i0.ɵɵcontentQuery(dirIndex, _c4, 7);
        i0.ɵɵcontentQuery(dirIndex, _c5, 7);
        i0.ɵɵcontentQuery(dirIndex, _c6, 7);
        i0.ɵɵcontentQuery(dirIndex, _c7, 7);
        i0.ɵɵcontentQuery(dirIndex, _c8, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.beforeTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.afterTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prependHeadsTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prependsTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.appendHeadsTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.appendsTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionsTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emptyTemplate = _t.first);
      }
    },
    viewQuery: function DotDualistComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(DotCheckboxesDirective, 7);
        i0.ɵɵviewQuery(DotCheckboxDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkboxes = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputs = _t);
      }
    },
    hostAttrs: [1, "dot-dualist", "_cut_for_child"],
    inputs: {
      actionsMoreAt: "actionsMoreAt",
      tipDelay: "tipDelay",
      outerFilter: "outerFilter"
    },
    outputs: {
      checks$: "checks$",
      checkSingle$: "checkSingle$",
      checkAll$: "checkAll$"
    },
    features: [i0.ɵɵProvidersFeature([DotSelfUrlService]), i0.ɵɵHostDirectivesFeature([i2.DotContainerDirective]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
    decls: 6,
    vars: 1,
    consts: [["headSort", ""], ["displayHeadFilter", ""], ["displayHeadFilterControl", ""], ["displayFilterActions", ""], ["input", ""], ["headCheckbox", ""], ["bodyItem", ""], ["dds", ""], ["displayDescriptionText", ""], ["displayBodyWithTemplate", ""], ["dotCheckboxes", ""], [4, "ngIf"], [1, "dot-dualist-sort"], ["dot-link", "", 1, "sort-link", "sort-link-toggle", 3, "click", "tip", "tipDelay"], [3, "innerHTML"], ["dot-link", "", 1, "sort-link", "sort-link-asc", 3, "click", "innerHTML", "tip", "tipDelay", "active"], ["dot-link", "", 1, "sort-link", "sort-link-desc", 3, "click", "innerHTML", "tip", "tipDelay", "active"], [4, "ngIf", "ngIfElse"], [3, "option", "data"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], ["dotInput", ""], [3, "textContent", 4, "ngIf"], ["dotPrefix", "", 3, "innerHTML", 4, "ngIf"], ["dotSelect", "", 3, "change", "value"], [3, "value", "innerHTML", 4, "ngFor", "ngForOf"], ["dotSuffix", "", 3, "innerHTML", 4, "ngIf"], [4, "ngTemplateOutlet"], [3, "textContent"], ["dotPrefix", "", 3, "innerHTML"], [3, "value", "innerHTML"], ["dotSuffix", "", 3, "innerHTML"], ["dotLabel", "", 3, "textContent", 4, "ngIf"], ["dotControl", "", 3, "keyup", "change", "focus", "type", "ngModel"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["dotLabel", "", 3, "textContent"], ["dotControl", "", 3, "keyup", "change", "type", "placeholder", "ngModel"], ["dot-link", "", "type", "button", "class", "filter-link filter-link-cancel", 3, "innerHTML", "tip", "tipDelay", "click", 4, "ngIf"], ["dot-link", "", "type", "submit", "class", "filter-link filter-link-submit", 3, "innerHTML", "tip", "tipDelay", "click", 4, "ngIf"], ["dot-link", "", "type", "button", 1, "filter-link", "filter-link-cancel", 3, "click", "innerHTML", "tip", "tipDelay"], ["dot-link", "", "type", "submit", 1, "filter-link", "filter-link-submit", 3, "click", "innerHTML", "tip", "tipDelay"], [3, "table"], ["dotZone", "datatableHead"], ["dot-heading", "", 3, "key", "ngClass"], ["dot-heading", "", "key", "list-actions", 3, "innerHTML"], ["dotLinkArea", "datatableBody", 4, "ngIf"], ["dotZone", "dataTableFoot", 4, "ngIf"], ["dot-heading", "", "key", "list-checkbox"], ["dotControl", "", "dotCheckboxesToggle", "", "type", "checkbox"], ["dot-component", "", 3, "option"], ["class", "dot-dualist-filter", 4, "ngIf"], [1, "dot-dualist-filter"], ["dotLinkArea", "datatableBody"], ["dot-value", "", "key", "list-checkbox"], ["dotControl", "", "dotCheckbox", "", "type", "checkbox", 3, "data"], [3, "innerHTML", 4, "ngIf"], ["dot-value", "", 3, "key", "routerLink", "queryParams", "label", "tip", "tipDelay", "ngClass"], ["dot-value", "", 1, "_clickable", 3, "click", "key", "label", "tip", "tipDelay", "ngClass"], ["dot-value", "", 3, "key", "label", "tip", "tipDelay", "ngClass"], ["dot-value", "", "key", "list-actions", 3, "label"], [3, "moreAt"], ["dotZone", "dataTableFoot"], [4, "ngFor", "ngForOf"], ["dot-value", "", 3, "key"], ["dot-value", ""]],
    template: function DotDualistComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, DotDualistComponent_ng_template_0_Template, 13, 22, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, DotDualistComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(4, "dot-area", 10);
        i0.ɵɵtemplate(5, DotDualistComponent_ng_container_5_Template, 15, 8, "ng-container", 11);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.listStableAdjusts$());
      }
    },
    dependencies: [CommonModule, i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i3.NgSwitch, i3.NgSwitchCase, i3.NgSwitchDefault, i3.AsyncPipe, DotListModule, i4.DotListComponent, i4.DotListHeadComponent, i4.DotListBodyComponent, i4.DotListFootComponent, i4.DotListItemComponent, i4.DotListNameComponent, i4.DotListValueComponent, DotFrameModule, i5.DotAreaComponent, DotComponent, DotListValuePipe, DotListDescriptionPipe, DotListLinkPipe, DotListFilterKeywordPipe, DotLinkModule, i6.DotLinkComponent, DotOfDefinePipe, DotIconModule, i7.DotIconPipe, DotCheckboxesDirective, DotCheckboxDirective, DotCheckboxesToggleDirective, DotInputModule, i8.DotInputControlDirective, i8.DotInputAreaComponent, i8.DotInputsComponent, i8.DotInputDirective, i8.DotInputActionsComponent, i8.DotLabelDirective, i8.DotLabelComponent, i8.DotSuffixDirective, i8.DotPrefixDirective, DotToMoreLinksModule, i9.DotToMoreLinksComponent, FormsModule, i10.NgSelectOption, i10.ɵNgSelectMultipleOption, i10.DefaultValueAccessor, i10.NgControlStatus, i10.NgModel, RouterLink, DotIncludesPipe, DotPromisifyPipe],
    styles: [":root{--list-back: var(transparent);--list-react-text: currentColor;--list-react-back: var(--t4a, #f0f0f0);--list-check-text: currentColor;--list-check-back: var(--p8a, #ffc)}.dot-dualist .dot-list._box .dot-list-heading{display:none}.dot-dualist .dot-list._box .dot-list-value dt{margin-right:1ch}.dot-dualist .dot-list._table{background-color:var(--list-back)}.dot-dualist .dot-list._table .dot-list-head{--link-gap: 0}.dot-dualist .dot-list._table .dot-list-head .dot-list-heading{white-space:nowrap}.dot-dualist .dot-list._table .dot-list-body .dot-list-item:hover{color:var(--list-react-text);background-color:var(--list-react-back)}.dot-dualist .dot-list._table .dot-list-body .dot-list-item:has(.item-list-checkbox input:checked){color:var(--list-check-text);background-color:var(--list-check-back)}.dot-dualist .dot-list._table .dot-list-body .dot-list-item .item-list-actions{white-space:nowrap;text-align:right}.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-asc,.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-desc{opacity:.24}.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-asc .dot-link-area,.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-desc .dot-link-area{padding-left:0;padding-right:0}.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-asc._active,.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-desc._active{opacity:1}.dot-dualist .dot-list._table .dot-dualist-filter{container-name:dot-list-filter;container-type:inline-size}.dot-dualist .dot-list._table .dot-dualist-filter .dot-input-area{width:100%}.dot-dualist .dot-list._table .dot-dualist-filter .dot-input-area .dot-input-control{min-height:var(--link-height)}.dot-dualist .dot-list._table .dot-dualist-filter .filter-link-cancel,.dot-dualist .dot-list._table .dot-dualist-filter .dot-label{display:none}.dot-dualist .item-list-checkbox{text-align:center}.dot-dualist ._clickable{cursor:pointer}@media (min-width: 960px){@container dot-list-filter (max-width:96 px){.dot-dualist-filter .filter-link-submit{display:none}}}@container dot-list-filter (min-width: 120px){.dot-dualist-filter .filter-link-cancel{display:inline-block!important}}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotDualistComponent, [{
    type: Component,
    args: [{
      imports: [CommonModule, DotListModule, DotFrameModule, DotComponent, DotListValuePipe, DotListDescriptionPipe, DotListLinkPipe, DotListFilterKeywordPipe, DotLinkModule, DotOfDefinePipe, DotIconModule, DotCheckboxesDirective, DotCheckboxDirective, DotCheckboxesToggleDirective, DotInputModule, DotToMoreLinksModule, FormsModule, RouterLink, DotIncludesPipe, DotPromisifyPipe],
      providers: [DotSelfUrlService],
      selector: 'dot-dualist',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'dot-dualist _cut_for_child'
      },
      hostDirectives: [{
        directive: DotContainerDirective
      }],
      template: "<ng-template #headSort let-adjust>\r\n\t\t\t<span class=\"dot-dualist-sort\">\r\n\t\t\t\t<button dot-link\r\n                        (click)=\"listSortToggle(adjust.target)\"\r\n                        class=\"sort-link sort-link-toggle\"\r\n                        [tip]=\"configure.sortToggleDefine | ofDefine\"\r\n                        [tipDelay]=\"tipDelay\"\r\n                >\r\n\t\t\t\t\t<span [innerHTML]=\"adjust.headingValue\"></span>\r\n                    @switch (_listSorts$()[adjust.target]) {\r\n                        @case (true) {\r\n                            <span [innerHTML]=\"configure.sortAscIcon | icon\"></span>\r\n                        }\r\n                        @case (false) {\r\n                            <span [innerHTML]=\"configure.sortDescIcon | icon\"></span>\r\n                        }\r\n                        @default {\r\n                            <span [innerHTML]=\"configure.sortToggleIcon | icon\"></span>\r\n                        }\r\n                    }\r\n\t\t\t\t</button>\r\n\r\n\t\t\t\t<button dot-link\r\n                        [innerHTML]=\"configure.sortAscIcon | icon\"\r\n                        [tip]=\"configure.sortAscDefine | ofDefine\"\r\n                        [tipDelay]=\"tipDelay\"\r\n                        [active]=\"_listSorts$()[adjust.target] === true\"\r\n                        (click)=\"listSortAsc(adjust.target)\"\r\n                        class=\"sort-link sort-link-asc\"\r\n                >\r\n\t\t\t\t</button>\r\n\t\t\t\t<button dot-link\r\n                        [innerHTML]=\"configure.sortDescIcon | icon\"\r\n                        [tip]=\"configure.sortDescDefine | ofDefine\"\r\n                        [tipDelay]=\"tipDelay\"\r\n                        [active]=\"_listSorts$()[adjust.target] === false\"\r\n                        (click)=\"listSortDesc(adjust.target)\"\r\n                        class=\"sort-link sort-link-desc\"\r\n                >\r\n\t\t\t\t</button>\r\n\t\t\t</span>\r\n</ng-template>\r\n\r\n<ng-template #displayHeadFilter let-adjust>\r\n    <ng-container *ngIf=\"adjust.filter;\">\r\n        <ng-container *ngIf=\"adjust.filter.component; let option else displayHeadFilterControl\">\r\n            <dot-component [option]=\"$any(option)\" [data]=\"adjust\"/>\r\n        </ng-container>\r\n\r\n        <ng-template #displayHeadFilterControl>\r\n            <dot-input-area [ngSwitch]=\"adjust.filter.type\">\r\n                <ng-container *ngSwitchCase=\"'select'\">\r\n                    <dot-inputs>\r\n                        <label dotInput>\r\n                            <dot-label *ngIf=\"adjust.filter.label; let value\"\r\n                                       [textContent]=\"value\"></dot-label>\r\n                            <span dotPrefix *ngIf=\"adjust.filter.prefix; let value\"\r\n                                  [innerHTML]=\"value\"></span>\r\n                            <select\r\n                                    dotSelect\r\n                                    (change)=\"listFilterOnChange($event, adjust)\"\r\n                                    [value]=\"_listKeywords$()[adjust.target]\"\r\n                            >\r\n                                <option [innerHTML]=\"'LIST_FILTER_SELECT_PLACEHOLDER' | ofDefine\"></option>\r\n                                <option *ngFor=\"let option of adjust.filter.options\"\r\n                                        [value]=\"option.value\"\r\n                                        [innerHTML]=\"option.text\"\r\n                                >\r\n                                </option>\r\n                            </select>\r\n                            <span dotSuffix *ngIf=\"adjust.filter.suffix; let value\"\r\n                                  [innerHTML]=\"value\"></span>\r\n                        </label>\r\n                        <ng-container *ngTemplateOutlet=\"displayFilterActions\"></ng-container>\r\n                    </dot-inputs>\r\n                </ng-container>\r\n                <ng-container *ngSwitchCase=\"'date'\">\r\n                    <dot-inputs>\r\n                        <label dotInput>\r\n                                        <span dotLabel *ngIf=\"adjust.filter.label; let label\"\r\n                                              [textContent]=\"label\"></span>\r\n                            <span dotPrefix *ngIf=\"adjust.filter.prefix; let value\"\r\n                                  [innerHTML]=\"value\"></span>\r\n                            <input\r\n                                    dotControl\r\n                                    [type]=\"adjust.filter.type\"\r\n                                    (keyup)=\"listOnFilterKeyUp($event, adjust)\"\r\n                                    (change)=\"listFilterOnChange($event, adjust)\"\r\n                                    (focus)=\"$any(input).showPicker()\"\r\n                                    [ngModel]=\"_listKeywords$()[adjust.target] | listFilterKeyword\"\r\n\t\t\t\t\t\t\t\t\t#input\r\n                            >\r\n                            <span dotSuffix *ngIf=\"adjust.filter.suffix; let value\"\r\n                                  [innerHTML]=\"value\"></span>\r\n                        </label>\r\n\r\n                        <ng-container\r\n                                *ngTemplateOutlet=\"displayFilterActions; context: {$implicit: input}\"></ng-container>\r\n                    </dot-inputs>\r\n                </ng-container>\r\n                <ng-container *ngSwitchDefault>\r\n                    <dot-inputs>\r\n                        <label dotInput>\r\n                                        <span dotLabel *ngIf=\"adjust.filter.label; let label\"\r\n                                              [textContent]=\"label\"></span>\r\n                            <span dotPrefix *ngIf=\"adjust.filter.prefix; let value\"\r\n                                  [innerHTML]=\"value\"></span>\r\n                            <input\r\n                                    dotControl\r\n                                    [type]=\"adjust.filter.type\"\r\n                                    [placeholder]=\"'LIST_FILTER_TEXT_PLACEHOLDER' | ofDefine\"\r\n                                    (keyup)=\"listOnFilterKeyUp($event, adjust)\"\r\n                                    (change)=\"listFilterOnChange($event, adjust)\"\r\n                                    [ngModel]=\"_listKeywords$()[adjust.target]\"\r\n\t\t\t\t\t\t\t\t\t#input\r\n                            >\r\n                            <span dotSuffix *ngIf=\"adjust.filter.suffix; let value\"\r\n                                  [innerHTML]=\"value\"></span>\r\n                        </label>\r\n                        <ng-container\r\n                                *ngTemplateOutlet=\"displayFilterActions; context: {$implicit: input}\"/>\r\n\r\n                    </dot-inputs>\r\n                </ng-container>\r\n            </dot-input-area>\r\n            <ng-template #displayFilterActions let-input>\r\n                <dot-input-actions>\r\n                    <!--                                <button *ngIf=\"adjust.filter.type == 'date' && configure.filterDatepickerIcon\"-->\r\n                    <!--                                        dot-link-->\r\n                    <!--                                        type=\"button\"-->\r\n                    <!--                                        [innerHTML]=\"configure.filterDatepickerIcon | icon\"-->\r\n                    <!--                                        (click)=\"listDatePicker(input)\"-->\r\n                    <!--                                ></button>-->\r\n                    <button *ngIf=\"_listKeywords$()[adjust.target]\"\r\n                            dot-link\r\n                            type=\"button\"\r\n                            class=\"filter-link filter-link-cancel\"\r\n                            [innerHTML]=\"configure.filterCancelIcon | icon\"\r\n                            [tip]=\"'LIST_FILTER_CANCEL' | ofDefine\"\r\n                            [tipDelay]=\"tipDelay\"\r\n                            (click)=\"listFilterCancel(adjust)\"\r\n                    ></button>\r\n                    <button *ngIf=\"!(['select', 'date'] | includes:adjust.filter.type)\"\r\n                            dot-link\r\n                            type=\"submit\"\r\n                            class=\"filter-link filter-link-submit\"\r\n                            [innerHTML]=\"configure.filterSubmitIcon | icon\"\r\n                            [tip]=\"'LIST_FILTER_SUBMIT' | ofDefine\"\r\n                            [tipDelay]=\"tipDelay\"\r\n                            (click)=\"listFilterSubmit()\"\r\n                    ></button>\r\n                </dot-input-actions>\r\n            </ng-template>\r\n\r\n        </ng-template>\r\n    </ng-container>\r\n</ng-template>\r\n\r\n<dot-area dotCheckboxes>\r\n    <ng-container *ngIf=\"listStableAdjusts$() let adjusts\">\r\n        <ng-template #headCheckbox>\r\n            @if (listCheckbox) {\r\n                <dl dot-heading key=\"list-checkbox\">\r\n                    <dd>\r\n                        <dot-input-area>\r\n                            <dot-inputs>\r\n                                <label dotInput>\r\n                                    <input dotControl dotCheckboxesToggle type=\"checkbox\">\r\n                                </label>\r\n                            </dot-inputs>\r\n                        </dot-input-area>\r\n                    </dd>\r\n                </dl>\r\n            }\r\n        </ng-template>\r\n\r\n        <dot-list [table]=\"table\">\r\n            <dot-list-head dotZone=\"datatableHead\">\r\n                <dot-list-item>\r\n                    <ng-container *ngTemplateOutlet=\"headCheckbox\"/>\r\n\r\n                    @if (prependHeadsTemplate) {\r\n                        <ng-container *ngTemplateOutlet=\"prependHeadsTemplate\"/>\r\n                    }\r\n\r\n                    @for(adjust of adjusts; track adjust){\r\n                        <dl dot-heading\r\n                            [key]=\"adjust.key\"\r\n                            [ngClass]=\"adjust.className\"\r\n                        >\r\n                            @if (adjust.heading.component; as option) {\r\n                                <dt dot-component [option]=\"option\"></dt>\r\n                            } @else if (listSort && adjust.sort) {\r\n                                <ng-container\r\n                                        *ngTemplateOutlet=\"headSort;  context: {$implicit: adjust}\"/>\r\n                            } @else {\r\n                                <dt [innerHTML]=\"adjust.headingValue\"></dt>\r\n                            }\r\n\r\n                            <dd *ngIf=\"!outerFilter && listFilter && configure.filter.position !== 'foot'\"\r\n                                class=\"dot-dualist-filter\">\r\n                                <ng-container\r\n                                        *ngTemplateOutlet=\"displayHeadFilter; context: {$implicit: adjust}\"/>\r\n                            </dd>\r\n                        </dl>\r\n\r\n                    }\r\n                    @if (appendHeadsTemplate) {\r\n                        <ng-container *ngTemplateOutlet=\"appendHeadsTemplate\"/>\r\n                    }\r\n\r\n                    @if(actionsTemplate){\r\n                        <dl dot-heading\r\n                            key=\"list-actions\"\r\n                            [innerHTML]=\"configure.actionsDefine | ofDefine\"\r\n                        ></dl>\r\n                    }\r\n                </dot-list-item>\r\n            </dot-list-head>\r\n\r\n            <dot-list-body *ngIf=\"listItems$(); let items\" dotLinkArea=\"datatableBody\">\r\n                <ng-container *ngTemplateOutlet=\"beforeTemplate\"/>\r\n                <ng-template #bodyItem let-item let-index=\"index\">\r\n                    @if(listCheckbox){\r\n                        <dl dot-value key=\"list-checkbox\">\r\n                            <dd>\r\n                                <dot-input-area>\r\n                                    <dot-inputs>\r\n                                        <label dotInput>\r\n                                            <input dotControl dotCheckbox [data]=\"item\" type=\"checkbox\">\r\n                                        </label>\r\n                                    </dot-inputs>\r\n                                </dot-input-area>\r\n                            </dd>\r\n                        </dl>\r\n                    }\r\n                    <ng-container *ngIf=\"prependsTemplate\">\r\n                        <ng-container\r\n                                *ngTemplateOutlet=\"prependsTemplate; context: {$implicit: item, index}\"></ng-container>\r\n                    </ng-container>\r\n                    @for (adjust of adjusts; track $index) {\r\n                        <ng-template #dds>\r\n                            @if(adjust.value.component; as component){\r\n                                <dd>\r\n                                    <dot-component\r\n                                            [option]=\"$any(component)\"\r\n                                            [data]=\"item | dotListValue: adjust\"\r\n                                    />\r\n                                </dd>\r\n                            }@else{\r\n                                <dd [innerHTML]=\"item | dotListValue: adjust\"></dd>\r\n                            }\r\n\r\n                            <dd *ngIf=\"adjust.description?.component; let component; else displayDescriptionText\">\r\n                                <dot-component\r\n                                        [option]=\"$any(component)\"\r\n                                        [data]=\"item | dotListDescription:adjust\"\r\n                                ></dot-component>\r\n                            </dd>\r\n                            <ng-template #displayDescriptionText>\r\n                                <dd *ngIf=\"adjust.description\"\r\n                                    [innerHTML]=\"item | dotListDescription: adjust\"></dd>\r\n                            </ng-template>\r\n                        </ng-template>\r\n                        <ng-container [ngSwitch]=\"adjust.eventType\">\r\n                            <ng-container *ngSwitchCase=\"'route'\">\r\n                                <a dot-value\r\n                                   [key]=\"adjust.key\"\r\n                                   [routerLink]=\"(item | dotListLink: adjust)\"\r\n                                   [queryParams]=\"routeParams\"\r\n                                   [label]=\"adjust.headingValue\"\r\n                                   [tip]=\"adjust.tip | promisify | async\"\r\n                                   [tipDelay]=\"tipDelay\"\r\n                                   [ngClass]=\"adjust.className\"\r\n                                >\r\n                                    <ng-container *ngTemplateOutlet=\"dds\"/>\r\n                                </a>\r\n                            </ng-container>\r\n                            <ng-container *ngSwitchCase=\"'click'\">\r\n                                <dl dot-value\r\n                                    [key]=\"adjust.key\"\r\n                                    [label]=\"adjust.headingValue\"\r\n                                    (click)=\"adjust.click(item)\"\r\n                                    [tip]=\"adjust.tip | promisify | async\"\r\n                                    [tipDelay]=\"tipDelay\"\r\n                                    class=\"_clickable\"\r\n                                    [ngClass]=\"adjust.className\"\r\n                                >\r\n                                    <ng-container *ngTemplateOutlet=\"dds\"/>\r\n                                </dl>\r\n                            </ng-container>\r\n                            <ng-container *ngSwitchDefault>\r\n                                <dl dot-value\r\n                                    [key]=\"adjust.key\"\r\n                                    [label]=\"adjust.headingValue\"\r\n                                    [tip]=\"adjust.tip | promisify | async\"\r\n                                    [tipDelay]=\"tipDelay\"\r\n                                    [ngClass]=\"adjust.className\"\r\n                                >\r\n                                    <ng-container *ngTemplateOutlet=\"dds\"/>\r\n                                </dl>\r\n                            </ng-container>\r\n                        </ng-container>\r\n\r\n                    }\r\n                    <ng-container *ngIf=\"appendsTemplate\">\r\n                        <ng-container\r\n                                *ngTemplateOutlet=\"appendsTemplate; context: {$implicit: item, index}\"/>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"actionsTemplate\">\r\n                        <dl dot-value key=\"list-actions\" [label]=\"configure.actionsDefine | ofDefine\">\r\n                            <dot-to-more-links [moreAt]=\"actionsMoreAt\">\r\n                                <ng-container\r\n                                        *ngTemplateOutlet=\"actionsTemplate; context: {$implicit: item}\"/>\r\n                            </dot-to-more-links>\r\n                        </dl>\r\n                    </ng-container>\r\n                </ng-template>\r\n\r\n                @if (itemTemplate) {\r\n                    @for (item of items; track listTrackBy($index, item)) {\r\n                        <ng-template #displayBodyWithTemplate>\r\n                            <ng-container\r\n                                    *ngTemplateOutlet=\"bodyItem; context: {$implicit: item, index: $index}\"/>\r\n                        </ng-template>\r\n                        <ng-container\r\n                                *ngTemplateOutlet=\"itemTemplate; context: {$implicit: displayBodyWithTemplate, item: item, index: $index}\"/>\r\n                    }\r\n                } @else {\r\n                    @for (item of items; track listTrackBy($index, item)) {\r\n                        <dot-list-item>\r\n                            <ng-container\r\n                                    *ngTemplateOutlet=\"bodyItem; context: {$implicit: item, index: $index}\"></ng-container>\r\n                        </dot-list-item>\r\n                    }\r\n                }\r\n\r\n                <ng-container *ngTemplateOutlet=\"afterTemplate\"/>\r\n            </dot-list-body>\r\n\r\n            <dot-list-foot\r\n                    *ngIf=\"listFilter && configure.filter.position !== 'head'\"\r\n                    dotZone=\"dataTableFoot\"\r\n            >\r\n                <ng-container *ngTemplateOutlet=\"headCheckbox\"/>\r\n                <ng-container *ngIf=\"prependHeadsTemplate\">\r\n                    <ng-container *ngTemplateOutlet=\"prependHeadsTemplate\"/>\r\n                </ng-container>\r\n                <ng-container *ngFor=\"let adjust of adjusts;\">\r\n                    <dl dot-value [key]=\"adjust.key\">\r\n                        <dd class=\"dot-dualist-filter\">\r\n                            <ng-container\r\n                                    *ngTemplateOutlet=\"displayHeadFilter; context: {$implicit: adjust}\"/>\r\n                        </dd>\r\n                    </dl>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"appendHeadsTemplate\">\r\n                    <ng-container *ngTemplateOutlet=\"appendHeadsTemplate\"/>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"actionsTemplate\">\r\n                    <dl dot-value></dl>\r\n                </ng-container>\r\n            </dot-list-foot>\r\n        </dot-list>\r\n\r\n        @if (listItems$() && listItems$().length === 0 && emptyTemplate) {\r\n            <ng-container *ngTemplateOutlet=\"emptyTemplate\"/>\r\n        }\r\n    </ng-container>\r\n</dot-area>\r\n",
      styles: [":root{--list-back: var(transparent);--list-react-text: currentColor;--list-react-back: var(--t4a, #f0f0f0);--list-check-text: currentColor;--list-check-back: var(--p8a, #ffc)}.dot-dualist .dot-list._box .dot-list-heading{display:none}.dot-dualist .dot-list._box .dot-list-value dt{margin-right:1ch}.dot-dualist .dot-list._table{background-color:var(--list-back)}.dot-dualist .dot-list._table .dot-list-head{--link-gap: 0}.dot-dualist .dot-list._table .dot-list-head .dot-list-heading{white-space:nowrap}.dot-dualist .dot-list._table .dot-list-body .dot-list-item:hover{color:var(--list-react-text);background-color:var(--list-react-back)}.dot-dualist .dot-list._table .dot-list-body .dot-list-item:has(.item-list-checkbox input:checked){color:var(--list-check-text);background-color:var(--list-check-back)}.dot-dualist .dot-list._table .dot-list-body .dot-list-item .item-list-actions{white-space:nowrap;text-align:right}.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-asc,.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-desc{opacity:.24}.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-asc .dot-link-area,.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-desc .dot-link-area{padding-left:0;padding-right:0}.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-asc._active,.dot-dualist .dot-list._table .dot-dualist-sort .sort-link-desc._active{opacity:1}.dot-dualist .dot-list._table .dot-dualist-filter{container-name:dot-list-filter;container-type:inline-size}.dot-dualist .dot-list._table .dot-dualist-filter .dot-input-area{width:100%}.dot-dualist .dot-list._table .dot-dualist-filter .dot-input-area .dot-input-control{min-height:var(--link-height)}.dot-dualist .dot-list._table .dot-dualist-filter .filter-link-cancel,.dot-dualist .dot-list._table .dot-dualist-filter .dot-label{display:none}.dot-dualist .item-list-checkbox{text-align:center}.dot-dualist ._clickable{cursor:pointer}@media (min-width: 960px){@container dot-list-filter (max-width:96 px){.dot-dualist-filter .filter-link-submit{display:none}}}@container dot-list-filter (min-width: 120px){.dot-dualist-filter .filter-link-cancel{display:inline-block!important}}\n"]
    }]
  }], () => [{
    type: DotDualistService
  }, {
    type: i1.DotRouteService
  }, {
    type: i1.DotSelfUrlService
  }], {
    checkboxes: [{
      type: ViewChild,
      args: [DotCheckboxesDirective, {
        static: true
      }]
    }],
    inputs: [{
      type: ViewChildren,
      args: [DotCheckboxDirective]
    }],
    actionsMoreAt: [{
      type: Input
    }],
    tipDelay: [{
      type: Input
    }],
    outerFilter: [{
      type: Input
    }],
    checks$: [{
      type: Output
    }],
    checkSingle$: [{
      type: Output
    }],
    checkAll$: [{
      type: Output
    }],
    beforeTemplate: [{
      type: ContentChild,
      args: ['listBefore', {
        static: true
      }]
    }],
    afterTemplate: [{
      type: ContentChild,
      args: ['listAfter', {
        static: true
      }]
    }],
    itemTemplate: [{
      type: ContentChild,
      args: ['listItem', {
        static: true
      }]
    }],
    prependHeadsTemplate: [{
      type: ContentChild,
      args: ['listPrependHeads', {
        static: true
      }]
    }],
    prependsTemplate: [{
      type: ContentChild,
      args: ['listPrepends', {
        static: true
      }]
    }],
    appendHeadsTemplate: [{
      type: ContentChild,
      args: ['listAppendHeads', {
        static: true
      }]
    }],
    appendsTemplate: [{
      type: ContentChild,
      args: ['listAppends', {
        static: true
      }]
    }],
    actionsTemplate: [{
      type: ContentChild,
      args: ['listActions', {
        static: true
      }]
    }],
    emptyTemplate: [{
      type: ContentChild,
      args: ['listEmpty', {
        static: true
      }]
    }]
  });
})();
const DOT_DUALIST_MODULE_CONFIGURE = new InjectionToken('#ng-dot/ui/dualist/configure');
class DotDualistService {
  configure;
  constructor(configures) {
    this.configure = (configures || []).reduce((target, source) => {
      return fusion(target, source);
    }, {
      sortToggleDefine: 'LIST_SORT_TOGGLE',
      sortAscDefine: 'LIST_SORT_ASC',
      sortDescDefine: 'LIST_SORT_DESC',
      actionsDefine: 'LIST_ACTIONS',
      headZoneName: 'datatableHead',
      bodyZoneName: 'datatableBody',
      footZoneName: 'datatableFoot',
      filter: {
        position: 'both'
      }
    });
  }
  static ɵfac = function DotDualistService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotDualistService)(i0.ɵɵinject(DOT_DUALIST_MODULE_CONFIGURE, 8));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotDualistService,
    factory: DotDualistService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotDualistService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [DOT_DUALIST_MODULE_CONFIGURE]
    }]
  }], null);
})();
class DotDualistModule {
  static forRoot(configure) {
    return {
      ngModule: DotDualistModule,
      providers: [{
        provide: DOT_DUALIST_MODULE_CONFIGURE,
        useValue: configure,
        multi: true
      }]
    };
  }
  static ɵfac = function DotDualistModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotDualistModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotDualistModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotDualistModule, [{
    type: NgModule
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DOT_DUALIST_MODULE_CONFIGURE, DotDualistComponent, DotDualistModule, DotDualistService };
